import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { SbValueBridgeState, SbValueBridgeStore } from './sb-value-bridge.store';
/** @deprecated Re-adding just allow the legacy value bridge component to work. DO NOT USE ELSEWHERE! */
@Injectable({ providedIn: 'root' })
export class SbValueBridgeQuery extends Query<SbValueBridgeState> {
    constructor(protected store: SbValueBridgeStore) {
        super(store);
    }

    selectParentGraphData() {
        return this.select((state) => state.parentGraphData);
    }

    selectChildGraphData() {
        return this.select((state) => state.childGraphData);
    }
}
